import { render, staticRenderFns } from "./acticePeopleForm.vue?vue&type=template&id=4af42864&scoped=true&"
import script from "./acticePeopleForm.vue?vue&type=script&lang=js&"
export * from "./acticePeopleForm.vue?vue&type=script&lang=js&"
import style0 from "./acticePeopleForm.vue?vue&type=style&index=0&id=4af42864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af42864",
  null
  
)

export default component.exports